import React, { useState } from 'react';
import { Button, Divider, Empty, Modal, Skeleton } from 'antd';
import LoadableContainer from '@components/LoadableContainer';
import { CloudSyncOutlined, DeleteOutlined } from '@ant-design/icons';
import { FileImageItem } from '@core/features';
import { Buffer } from 'buffer';
import FileImageItemCard from './FileImageItemCard';
type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onUpload: (uploadedFileItems: FileImageItem[]) => void;
};

const UploadImageModal = ({ open, setOpen, onUpload }: Props) => {
  const [fileImageItems, setFileImageItems] = useState<FileImageItem[]>([]);
  const [selectedItems, setSelectedItems] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState<boolean>(false);

  const handleImageItemClicked = (item: FileImageItem) => {
    setSelectedItems({
      ...selectedItems,
      [item.id]: !selectedItems[item.id],
    });
  };

  const handleUploadImage = async (e: any) => {
    setLoading(true);
    const fileList = e.target.files as FileList;
    const uploadedFiles = [];
    for (let i = 0; i < fileList.length; i++) {
      const fileListItem = fileList.item(i);
      if (fileListItem) {
        uploadedFiles.push(fileListItem);
      }
    }
    for (let i = 0; i < uploadedFiles.length; i++) {
      const file = uploadedFiles[i];
      const filename = uploadedFiles[i].name;
      const extension = uploadedFiles[i].type;

      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = function (e) {
        if (!e.target || !e.target.result) return;
        const data = e.target.result as ArrayBuffer;
        const imageItem: FileImageItem = {
          id: Date.now() + Math.floor(Math.random() * 100000),
          extension: extension,
          name: filename,
          url: `data:${extension};base64,${Buffer.from(data).toString('base64')}`,
          data: data,
        };
        setFileImageItems(urls => urls.concat([imageItem]));
      };
    }
    setLoading(false);
  };

  const handleClearSelected = () => {
    setFileImageItems(items => (items = items.filter(item => !selectedItems[item.id])));
  };

  const handleCloseModal = () => {
    setFileImageItems([]);
    setOpen(false);
  };

  const handleUpload = async () => {
    handleCloseModal();
    await onUpload(fileImageItems);
  };

  return (
    <Modal
      title="Upload image"
      centered
      open={open}
      onOk={handleUpload}
      onCancel={handleCloseModal}
      okText={
        <div>
          <CloudSyncOutlined /> Upload
        </div>
      }
      width={'fit-content'}>
      <React.Fragment>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <input type="file" onChange={handleUploadImage} multiple />
          <Button onClick={handleClearSelected}>
            <DeleteOutlined /> Remove
          </Button>
        </div>
        <Divider />
        <LoadableContainer isLoading={loading} loadComponent={<Skeleton />}>
          <LoadableContainer
            isLoading={fileImageItems.length === 0}
            loadComponent={
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={<span>No images uploaded</span>}
              />
            }>
            <React.Fragment>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {fileImageItems.map(fileImageItem => (
                  <FileImageItemCard
                    onClick={item => handleImageItemClicked(item)}
                    isSelected={selectedItems[fileImageItem.id]}
                    item={fileImageItem}
                  />
                ))}
              </div>
            </React.Fragment>
          </LoadableContainer>
        </LoadableContainer>
      </React.Fragment>
    </Modal>
  );
};

export default UploadImageModal;
